module.exports = __webpack_public_path__ + "img/calculator-adjs.e3dbb238.png";